import React from 'react'

import { ModalRestrictor } from '@sketch/components'

import { NestedProjectItemGridView } from './NestedProjectItemGridView'
import { NestedProjectItemListView } from './NestedProjectItemListView'

import { NestedProjectFragment } from '@sketch/gql-types'
import { RenderNestedProjectDropdown } from './types'

interface NestedProjectItemProps {
  nestedProject: NestedProjectFragment
  workspaceIdentifier: string
  onClick?: React.MouseEventHandler<HTMLElement>
  renderDropdown: RenderNestedProjectDropdown
  disabledDrag: boolean
  presentation: 'grid' | 'list'
}

const NestedProjectItem: React.FC<NestedProjectItemProps> = ({
  nestedProject,
  workspaceIdentifier,
  presentation,
  onClick,
  renderDropdown,
  disabledDrag,
}) => {
  const Component =
    presentation === 'grid'
      ? NestedProjectItemGridView
      : NestedProjectItemListView

  return (
    <ModalRestrictor>
      <Component
        data-testid="nestedProject-item"
        nestedProject={nestedProject}
        workspaceIdentifier={workspaceIdentifier}
        renderDropdown={() => renderDropdown(nestedProject)}
        onClick={onClick}
        disabledDrag={disabledDrag}
      />
    </ModalRestrictor>
  )
}

export default NestedProjectItem
